import { ContentSection, PreviewLinks, SelectDirections, Directions, Hero, Anchors, Appointment } from '@/components';
import { StyledContent, StyledButton, StyledSection } from '@/components/styles';
import { useRouter } from 'next/router';
import { usePromise, usePartialQuery } from '@/hooks';
import { useRef, useMemo, useEffect, useState } from 'react';
import genLinkParams from '@/lib/generateLinkParams';
import api from '@/lib/api';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

function calcCurrentDirection(queryDirection, directions, defaultDirection) {
  if (!queryDirection) {
    return defaultDirection;
  } else {
    const currentDirection = directions.reduce((acc, cur) => {
      return cur.slug === queryDirection ? cur : cur.children?.find((i) => i.slug === queryDirection) ? cur : acc;
    }, null);
    return currentDirection || defaultDirection;
  }
}

const AppointmentView = (props) => {
  const { t } = useTranslation('global');
  return (
    <StyledButton style={{ width: '100%' }} size="mid" light arrow {...props}>
      {t('bookAppointment')}
    </StyledButton>
  );
};


export default function ServicesPage(props) {
  const { banners, directions, short_content } = props;
  const { t } = useTranslation('global');
  const cancelTokenSource = useRef(axios.CancelToken.source());

  const router = useRouter();
  const queryParams = usePartialQuery(['direction']);

  const defaultDirection = directions[0];
  const cur = useMemo(() => calcCurrentDirection(queryParams.direction, directions, defaultDirection), [queryParams]);

  const directionsPromise = usePromise(
    () => api.directions({  direction: queryParams?.direction? queryParams.direction : cur?.children?.[0]?.slug || cur?.slug, cancelToken: cancelTokenSource.token }),
    [queryParams, cur, router],
    {},
    () => cancelTokenSource.current.cancel()
  );

  const ServicesLink = () => {
    const { t } = useTranslation('global');
    const href = !queryParams.direction ? `/services?direction=${cur?.slug || ''}` : `/services`;
    return (<StyledButton as={'a'} href={href} style={{ width: '100%' }} size="mid" light arrow >
      {t('main.servises.button')}
    </StyledButton>)
  }


  const handleClick = (slug) => {
    const active = directions.reduce((acc, cur) => {
      return cur.slug === slug
        ? cur
        : cur.children?.find((i) => i.slug === slug)
          ? cur.children?.find((i) => i.slug === slug)
          : acc;
    }, null);

    if (active && (active.service_count > 0 || active.children?.length)) {
      if (active.children?.length) {
        router.push(
          { pathname: router.pathname, query: { direction: active.children[0].slug } },
          { pathname: location.pathname, query: { direction: active.children[0].slug } },
          { shallow: false }
        );
      } else {
        router.push(
          { pathname: router.pathname, query: { direction: slug } },
          { pathname: location.pathname, query: { direction: slug } },
          { shallow: false }
        );
      }
    } else {
      router.push({ pathname: `/${slug}`, query: {} }, { pathname: `/${slug}`, query: {} }, { shallow: true });
    }
  };

  let breadcrumbs = [
    {
      id: 1,
      title: t('main.titlePage'),
      slug: '',
      type: 'index',
    },
    {
      id: 2,
      title: 'OUR SERVICES',
      slug: '',
      type: 'services',
    },
    {
      id: 3,
      title: cur.title || '',
      link: `/services?direction=${cur?.slug}`,
      slug: cur.slug || '',
      type: 'direction',
    },
  ];
  let breadcrumbs2 = [
    {
      id: 4,
      title: t('main.titlePage'),
      slug: '',
      type: 'index',
    },
    {
      id: 5,
      title: 'OUR SERVICES',
      slug: '',
      type: 'services',
    },
  ];

  useEffect(() => {
    if (cur && cur.children?.length && (queryParams.direction && queryParams.direction == cur.slug)) {
      router.push(
        { pathname: router.pathname, query: { direction: cur.children[0].slug } },
        { pathname: location.pathname, query: { direction: cur.children[0].slug } },
        { shallow: false }
      );
    }
  }, [cur, queryParams]);

  return (
    <>
      {!!banners?.length && (
        <Hero
          data={banners}
          center={true}
          size="mid"
          breadcrumbs={queryParams.direction ? [...breadcrumbs] : [...breadcrumbs2]}
        />
      )}
      <StyledContent>
        <div style={{ overflow: 'hidden' }}>
          <StyledContent.Container hiddenMobile={!queryParams.direction}>
            {!!directions?.length && <Directions directions={directions} active={cur} onClick={handleClick} center />}
          </StyledContent.Container>
          <StyledContent.Container hiddenDesktop visibleMobile={!queryParams.direction}>
            {!!directions?.length && <PreviewLinks data={directions} items linksType="directions" />}
          </StyledContent.Container>
        </div>
        <StyledContent.Container hiddenMobile={!queryParams.direction}>
          <StyledContent.Columns>
            <div>
              <StyledContent.Side>
                {!!cur?.children?.length &&
                  directionsPromise?.status !== 'pending' &&
                  directionsPromise?.result?.current_direction && (
                    <StyledContent.Select>
                      <SelectDirections
                        directions={cur.children}
                        active={directionsPromise?.result?.current_direction}
                        onChange={handleClick}
                        disabled={directionsPromise?.status === 'pending'}
                        scrollTop
                      />
                    </StyledContent.Select>
                  )}
                {!!cur?.children?.length &&
                  directionsPromise?.status !== 'pending' &&
                  directionsPromise?.result?.current_direction && (
                    <Anchors
                      list={cur.children}
                      active={directionsPromise?.result?.current_direction?.slug}
                      handleClick={handleClick}
                    />
                  )}
                <div style={{ marginTop: '20px' }} className="button-wrap">
                  <Appointment render={AppointmentView} />
                </div>
              </StyledContent.Side>
            </div>
            <StyledContent.ColumnMain>
              <StyledContent.Loadable isLoading={directionsPromise?.status === 'pending'}>
                {directionsPromise?.status !== 'pending' && !!directionsPromise?.result?.services && (
                  <>
                    <ContentSection noTitle >
                      <PreviewLinks data={directionsPromise.result.services} items={3} />
                    </ContentSection>
                  </>
                )}
              </StyledContent.Loadable>
            </StyledContent.ColumnMain>
          </StyledContent.Columns>
        </StyledContent.Container>
        <StyledContent.Container hiddenDesktop visibleMobile>
          <div style={{ marginTop: '25px' }} className="button-wrap">
            <Appointment render={AppointmentView} />
          </div>
          <div style={{ marginTop: '25px' }}>
            <ServicesLink />
          </div>
        </StyledContent.Container>
        <StyledContent.Container>
          {short_content && (
            <StyledSection pt="none" pb="large">
              <StyledContent.Description>
                <StyledContent.Html dangerouslySetInnerHTML={{ __html: short_content }} dark />
              </StyledContent.Description>
            </StyledSection>
          )}
          <div></div>
        </StyledContent.Container>
      </StyledContent>
    </>
  );
}
